<div class="zwi-search-bar">
  <mat-icon (click)="onSearch()" class="zwi-search__button" [ngClass]="{'zwi-search__button--active': hasValue()}">
    search
  </mat-icon>
  <input (input)="onInput($event)" (focus)="emitFocus()" (keyup.enter)="onSearch()" [value]="value" autocapitalize="none" type="text" class="zwi-search-bar__input"/>
  @if (hasValue()) {
    <button type="button" mat-icon-button aria-label="Clear" (click)="clear()" class="zwi-search__clear">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
